import { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Switch,
  Typography,
} from '@material-ui/core';
import { bool, string } from 'prop-types';
import Client, { SERVICES } from 'services/dynamipay';

function MSIControl(props) {
  const {
    disabled,
    error,
    helperText,
    name,
    amountField = 'amount',
  } = props;

  const { values, setFieldValue } = useFormikContext();

  const [msiOptions, setMsiOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchMsiOptions() {
      try {
        const response = await Client(SERVICES.SERVICE_MSI).get();
        const msiData = response.values?.msi || response.values || {};
        const options = Object.entries(msiData).map(([months, minAmount]) => ({
          months: parseInt(months),
          minAmount: parseInt(minAmount),
        }));
        setMsiOptions(options);
      } catch (err) {
        console.error('Error fetching MSI options:', err);
        setMsiOptions([]);
      } finally {
        setLoading(false);
      }
    }
    fetchMsiOptions();
  }, []);

  const amount = parseFloat(values[amountField]) || 0;
  const msiEnabled = values?.config?.msi?.enabled || false;
  const selectedMonths = values?.config?.msi?.months || [];

  const availableOptions = msiOptions.filter(
    (option) => amount >= option.minAmount,
  );

  const handleEnableChange = (event) => {
    const enabled = event.target.checked;
    setFieldValue('config.msi.enabled', enabled);
    if (!enabled) {
      setFieldValue('config.msi.months', []);
    }
  };

  const handleMonthsChange = (months) => {
    const currentMonths = [...selectedMonths];
    const index = currentMonths.indexOf(months);

    if (index === -1) {
      currentMonths.push(months);
    } else {
      currentMonths.splice(index, 1);
    }

    currentMonths.sort((a, b) => a - b);
    setFieldValue('config.msi.months', currentMonths);
  };

  return (
    <Box>
      <FormControl
        component="fieldset"
        disabled={disabled}
        error={error}
        fullWidth
      >
        <FormControlLabel
          control={
            <Switch
              checked={msiEnabled}
              onChange={handleEnableChange}
              name={`${name}.enabled`}
              color="primary"
            />
          }
          label="Habilitar meses sin intereses"
        />

        {msiEnabled && (
          <Box mt={2} ml={2}>
            {loading ? (
              <Box display="flex" alignItems="center" gridGap={8}>
                <CircularProgress size={20} />
                <Typography variant="body2" color="textSecondary">
                  Cargando opciones...
                </Typography>
              </Box>
            ) : availableOptions.length > 0 ? (
              <>
                <FormLabel component="legend">
                  <Typography variant="body2" color="textSecondary">
                    Selecciona los meses disponibles para tus clientes
                  </Typography>
                </FormLabel>
                <FormGroup row>
                  {availableOptions.map((option) => (
                    <FormControlLabel
                      key={option.months}
                      control={
                        <Checkbox
                          checked={selectedMonths.includes(option.months)}
                          onChange={() => handleMonthsChange(option.months)}
                          name={`${name}.months`}
                          color="primary"
                        />
                      }
                      label={`${option.months} meses`}
                    />
                  ))}
                </FormGroup>
              </>
            ) : (
              <Typography variant="body2" color="textSecondary">
                El monto mínimo para meses sin intereses es de $500 MXN
              </Typography>
            )}

            {/* {amount > 0 && amount < 500 && (
              <Typography variant="caption" color="error">
                Monto insuficiente. Mínimo $500 para 3 MSI.
              </Typography>
            )} */}
          </Box>
        )}

        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </Box>
  );
}

MSIControl.propTypes = {
  amountField: string,
  disabled: bool,
  error: bool,
  helperText: string,
  name: string,
};

MSIControl.defaultProps = {
  amountField: 'amount',
  disabled: false,
  error: false,
  name: 'config.msi',
};

export default MSIControl;
